/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import { Input, InputGroup, Icon, Loader } from 'rsuite'
import { NoSearchResults } from '../Components/Icons'
import '../Components/Styles/activities.css'
import Card from '../Components/Card'
import { getEverithyng, getActivities } from '../Context/prismic'
import { addFavoriteActivities, getUsersCollection as getUsersCollectionFB } from '../Context/firebase'
const inputStyles = {
  width: 300,
  marginTop: 36,
  marginLeft: 49
}

const NoMatches = () => (
  <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
    <span className='no-matches-text'>Sorry, we couldn’t find anything like that. Give it another try</span>
    <NoSearchResults />
  </div>
)

const ActivitiesLibrary = ({
  setActivityDescriptionShown, isActivityPickerVisible, setSelectedActivity,
  showOnlyFavorites, goals
}) => {
  const [activities, setActivities] = useState(null) // full api response
  const [searchActivity, setSearchActivity] = useState('')
  const [updated, setUpdated] = useState(false)
  const [favorites, setFavorites] = useState([])
  const [areFavsLoaded, setFavsLoaded] = useState(false)

  // TODO: change saving favorites
  // getting user's collection and activities data from firebase
  useEffect(() => {
    setUpdated(true)
    const getUsersCollection = async () => {
      try {
        const usersCollection = await getUsersCollectionFB()
        setFavorites(usersCollection.favorites)
        setFavsLoaded(true)
        return usersCollection
      } catch (err) {
        console.error(err)
      }
      return setUpdated(false)
    }
    const getData = async () => {
      const usersCollection = await getUsersCollection()
      if (showOnlyFavorites) {
        getActivities(usersCollection?.favorites).then(setActivities)
      } else {
        getEverithyng()
          .then(data => filterActivitiesForGlobalGoals(data))
          .then(setActivities)
      }
    }
    getData()
  }, [])
  const filteredActivities = activities?.filter(activity =>
    activity?.data?.title[0]?.text.toLowerCase().includes(searchActivity.toLowerCase())
  )

  // TODO: Add categories tags
  const categories = [...new Set(filteredActivities?.reduce((acc, el) => acc.concat(el.tags), []))]

  // saving favorites to firestore
  useEffect(() => {
    const saveFavorites = async () => {
      try {
        await addFavoriteActivities(favorites)
        showOnlyFavorites && await getActivities(favorites)
          .then(setActivities)
      } catch (err) {
        console.error(err)
      }
    }
    areFavsLoaded && saveFavorites()
  }, [favorites])

  const updateFavorites = activity => {
    const isFavorite = favorites.find(item => item === activity)
    if (isFavorite) {
      const unFavorite = favorites.filter(item => item !== activity)
      setFavorites(unFavorite)
    } else {
      setFavorites(prev => [...prev, activity])
    }
  }
  // TODO: change saving favorites

  let emptyCardsCounter = 0
  const handleSearchChange = text => setSearchActivity(text)

  const filterActivitiesForGlobalGoals = activities => {
    if (goals) {
      const filtered = activities.map(item => {
        const itemGoals = item?.data?.global_goals?.map(itm => itm.goal)
        const doesContain = goals.some(el => itemGoals.includes(el))
        return doesContain && item
      })
      return filtered
    } else return activities
  }

  return (
    <div className='vertical-flex'>
      <h1 className='h1' style={{ marginLeft: '49px' }}>{showOnlyFavorites
        ? 'Favorites'
        : 'Activities'}
      </h1>
      <div className='border'>
        <div className='library' style={{ marginLeft: '49px' }}>
          <p>Library</p>
        </div>
      </div>
      <InputGroup inside style={inputStyles}>
        <InputGroup.Button>
          <Icon icon='search' />
        </InputGroup.Button>
        <Input placeholder='Search activities' onChange={handleSearchChange} value={searchActivity} />
      </InputGroup>

      {activities !== null
        ? <>
          <div className='horizontal-flex-AC' style={{ marginLeft: '35px' }}>
            {categories.map((category, index) => {
              return (
                <div key={index}>
                  <div className='horizontal-flex-AC' style={{ width: '100%' }}>
                    <h1 className='h1' style={{ width: '100%', margin: '15px' }}>{category} </h1>
                  </div>

                  <div className='vertical-flex-AC'>
                    <div className='horizontal-flex-AC' style={{ justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                      {filteredActivities.map((item, index) => {
                        if (item.tags.includes(category)) {
                          return (
                            <div>
                              <Card
                                key={index}
                                card={item}
                                isFavorite={item.isFavorite}
                                isActivityPickerVisible={isActivityPickerVisible}
                                setActivityDescriptionShown={setActivityDescriptionShown}
                                setSelectedActivity={setSelectedActivity}
                                updateFavorites={updateFavorites}
                                favorites={favorites}
                              />
                            </div>
                          )
                        } else {
                          emptyCardsCounter++
                          return ''
                        }
                      }
                      )}
                    </div>
                  </div>
                </div>
              )
            }
            )}
            {/* uncategorized activities */}
            <div className='horizontal-flex-AC' style={{ marginTop: '30px' }}>
              {filteredActivities.map((item, index) => {
                if (!item.tags.length) {
                  return (
                    <>
                      <Card
                        key={index}
                        card={item}
                        isFavorite={item.isFavorite}
                        isActivityPickerVisible={isActivityPickerVisible}
                        setActivityDescriptionShown={setActivityDescriptionShown}
                        setSelectedActivity={setSelectedActivity}
                        updateFavorites={updateFavorites}
                        favorites={favorites}
                      />
                    </>
                  )
                } else {
                  emptyCardsCounter++
                  return ''
                }
              })}
            </div>
          </div>
          {emptyCardsCounter === activities.length && <NoMatches />}
        </>
        : <div style={{ height: '100vh' }}> <Loader backdrop size='lg' content='loading...' vertical /> </div>}
    </div>

  )
}

export default ActivitiesLibrary
